import { Currency } from '@/core/currency/interfaces';

const BHD: Currency = {
    name: 'Bahraini Dinar',
    demonym: 'Bahraini',
    majorSingle: 'Dinar',
    majorPlural: 'Dinars',
    codeNumeric: '048',
    symbol: 'BD',
    symbolNative: 'د.ب.',
    minorSingle: 'Fils',
    minorPlural: 'Fils',
    ISOdigits: 3,
    decimals: 3,
    numToBasic: 1000,
    code: 'BHD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default BHD;
